import React from "react";
import { Button } from "react-bootstrap";
import { Trans } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import phFeMale from "../../../assets/images/blurred2/female/lower_shadow_female.jpg";
import phStart_struk from "../../../assets/images/blurred2/imoji/star_struk.png";
import phThumbsUp from "../../../assets/images/blurred2/imoji/thumb_up_1.png";
import phMale from "../../../assets/images/blurred2/male/lower_shadow_male.jpg";
import BarChart from "../../../components/BarChart";
import ImageLoader from "../../../components/ImageLoader";
import MobileViewLayout from "../../../layouts/MobileViewLayout";
import { addS3Url, nextPageRoute } from "../../../utils/modules";

const imagesToPreload = [
  "/wishes/house.png",
  "/wishes/ring.png",
  "/wishes/bag.png",
  "/wishes/car.png",
  "/wishes/juice_glass.png",
];

const ProfileSummary = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [percent, setPercent] = React.useState(0);
  const [color, setColor] = React.useState("red");
  const dispatch = useDispatch();

  React.useEffect(() => {
    const interval = setInterval(() => {
      setPercent((prevPercentage) => {
        const newPercentage = prevPercentage + 1;
        if (newPercentage > 25) {
          setColor("red,orange");
        }
        if (newPercentage >= 50) {
          setColor("red,orange,green");
        }
        if (newPercentage >= 75) {
          clearInterval(interval);
        }
        return newPercentage;
      });
    }, 30);

    return () => clearInterval(interval);
  }, []);

  const gradient = `conic-gradient(${color} ${percent * 3.6}deg, transparent ${
    percent * 3.6
  }deg)`;

  return (
    <MobileViewLayout>
      <div className="flex-grow-1 px-3">
        <h1
          className="fw-bold text-center fs30"
          style={{
            paddingTop: "40px",
            paddingBottom: "11px",

            margin: "0 0",
          }}
        >
          <Trans
            i18nKey={"summary_screen.title"}
            components={{
              tag: <span className="textSecondary" />,
              line: <br />,
            }}
          />
        </h1>
        <div
          className="px-2"
          style={{
            borderRadius: "5px",
            borderStyle: "solid",
            margin: "10px 0px",
            borderWidth: "1px",
            borderColor: "#DBDBDB",
          }}
        >
          <div
            className="d-flex flex-row justify-content-between align-items-center "
            style={{ padding: "20px 5px" }}
          >
            <p className="fw-bold smallText m-0">
              <Trans
                i18nKey={"summary_screen.readiness_score"}
                components={{ tag: <br /> }}
              />
            </p>
            <Button
              className="fw-bold smallText d-flex flex-row align-items-center m-0 bgSecondary"
              style={{ padding: "2px 5px", gap: "5px" }}
            >
              <Trans i18nKey={"summary_screen.result_perfect"} />
              <ImageLoader
                placeHolderImage={phStart_struk}
                src={addS3Url("/imoji/star_struk.png")}
                alt="star_struk_emoji"
                style={{
                  maxHeight: "18px",
                  maxWidth: "18px",
                  objectFit: "contain",
                }}
              />
            </Button>
          </div>
          <div className="w-100 d-flex flex-row justify-content-between align-items-center py-2 pb-3 ">
            <div
              className="px-3"
              style={{
                width: "48%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  aspectRatio: "1/1",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#d6d6d6",
                  borderRadius: "50%",
                  position: "relative",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    aspectRatio: "1/1",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    background: gradient,
                    borderRadius: "50%",
                    zIndex: 1,
                  }}
                >
                  <div
                    style={{
                      width: "83%",
                      aspectRatio: "1/1",
                      backgroundColor: "white",
                      borderRadius: "50%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <strong
                      style={{ margin: 0, fontWeight: "bolder" }}
                      className="fs30"
                    >
                      {percent.toFixed(1)}
                    </strong>
                    <span
                      style={{ margin: 0, fontSize: "10px" }}
                      className="fw-normal"
                    >
                      <Trans i18nKey={"summary_screen.required_score"} />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ width: "48%" }}>
              <ImageLoader
                src={
                  params.gender === "male"
                    ? addS3Url("/staging/male/lower_shadow_male.webp")
                    : addS3Url("/staging/female/lower_shadow_female.webp")
                }
                placeHolderImage={params.gender === "male" ? phMale : phFeMale}
                alt="male_img"
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div
            className="w-100 d-flex justify-content-center align-items-center pb-3 "
            style={{ minHeight: "200px" }}
          >
            <BarChart ratings={[8.7, 8.5, 6.7, 5.0]} />
          </div>
        </div>
        <div
          className="d-flex flex-row w-100 justify-content-center gap-2 p-2"
          style={{
            backgroundColor: "#F5F5F5",
            borderRadius: "5px",
          }}
        >
          <div>
            <ImageLoader
              placeHolderImage={phThumbsUp}
              src={addS3Url("/imoji/thumb_up_1.png")}
              alt="thumb_up"
              style={{ width: "28px", height: "28px", objectFit: "contain" }}
            />
          </div>
          <div>
            <p className="profilesummary-small-text fw-bold m-0 text-start ">
              <Trans i18nKey={"summary_screen.impressive_score"} />
            </p>
            <p className="profilesummary-small-text fw-normal m-0 text-start ">
              <Trans i18nKey={"summary_screen.description"} />
            </p>
          </div>
        </div>
        <Button
          onClick={() =>
            nextPageRoute(
              navigate,
              `/${params.gender}/wishes`,
              dispatch,
              imagesToPreload
            )
          }
          className="w-100 fw-bold mb-3 fs18 bgSecondary sticky-button text-capitalize"
          style={{ marginTop: "18px", padding: "10px 0px", height: "60px" }}
        >
          <Trans i18nKey={"common_text.continue"} />
        </Button>
      </div>
    </MobileViewLayout>
  );
};

export default ProfileSummary;
